
import { defineComponent, markRaw, PropType } from 'vue'
import RollBase from '@/features/RollSkillDice/rollTypes/RollBase.vue'
import { RollType, SkillProgress } from '@/types'
import { Button } from '@/shared/ui'
import RollAttack from '@/features/RollSkillDice/rollTypes/RollAttack.vue'
import RollDefence from '@/features/RollSkillDice/rollTypes/RollDefence.vue'

export default defineComponent({
	name: 'RollWindow',
	props: {
		skill: {
			type: Object as PropType<SkillProgress>,
			required: true
		}
	},
	components: {
		RollBase,
		RollAttack,
		RollDefence,
		Button
	},
	data() {
		return {
			rollType: RollType.Overcome,
			rollTypes: markRaw(
				Object.fromEntries([
					[RollType.Overcome, RollBase],
					[RollType.Advantage, RollBase],
					[RollType.Attack, RollAttack],
					[RollType.Defence, RollDefence]
				])
			)
		}
	},
	computed: {
		component() {
			return this.rollTypes[this.rollType]
		}
	},
	methods: {
		changeRollType(type: string) {
			this.rollType = type as RollType
		}
	}
})
